<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        
        
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="col-md-12">
        <div class="row">
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Debut <span class="text-danger">*</span>
                </label>
                <Field name="dateDebut" type="date" v-model="_dateDebut"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateDebut" class="text-danger"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Fin <span class="text-danger">*</span>
                </label>
                <Field name="dateFin" type="date"  v-model="_dateFin"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateFin" class="text-danger"/>
              </div>
            </div>

            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Produit <span class="text-danger">*</span>
                </label>
                <Field v-model="_produit" name="produit" v-slot="{ field }">
                  <Multiselect
                    :options="produitOptions" 
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner un produit"
                  />
                </Field>
                <ErrorMessage name="produit" class="text-danger"/>
              </div>
            </div>
            
  
          <!-- </form> -->
        </div>
        </div>
        <hr>
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Date
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Operation
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  Qte
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  Stock
                </th>
              </tr>
            </thead>
            <tbody>
              
              <tr v-for="(el, index) in elements" :key="index">

                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ format_Date(el.date) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ el.type }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ el.quantity }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  
                  {{  el.cumulativeTotal }}
                </td>
              </tr>
              <!-- <tr>
                <td colspan="6" class="text-end"> Total : </td>
                <td> <h5> <b>{{ formatMontant(total) }}</b></h5>  </td>
              </tr> -->
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
  
        </div>
      </div>
    </div>
  
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref, watch } from "vue";
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from "@/services/ApiService";
  import { useRouter, useRoute } from 'vue-router';
  import { format_date,suppression,format_Date, hideModal, showModal,separateur, error,success, getCurrentDate } from "@/utils/utils";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
  import Multiselect from '@vueform/multiselect';
  import axios from "axios";
  import { Reglement } from '../../models/Reglement';
  
  export default defineComponent({
      name: "FicheProduit",
      components: {
        // Form,
        Field,
        Multiselect,
        PaginationComponent,
    },
    setup: () => {
  
      const elements = ref<Array<any>>([]);
      const elementsAppro = ref<Array<any>>([]);
      const elementsVente = ref<Array<any>>([]);
      const reglement = ref<Reglement>();
      const ResiliationRef = ref<null | HTMLElement>(null);
      const modeleOptions = ref([]);
      const agentOptions = ref([]);
      const clientOptions = ref([]);
      const venteOptions = ref([]);
      const categorieAbonneOptions = ref([]);
      const total = ref(0);

  
      // BEGIN PAGINATE
      const _dateDebut = ref(null);
      const _dateFin = ref(null);
      const _agent = ref('');
      const _client = ref('');
      const _vente = ref('');
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
      const router = useRouter();
      const route = useRoute();
  
      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          // getAll(page_, limit_);
        } catch (error) {
          //
        }
      };
     
  
      // watch([_dateDebut, _dateFin, _agent, _client, _vente, searchTerm], () => {
      //   console.log('watching', _dateDebut, _dateFin, _agent);
      //   rechercher();
      // });

    
  
      function rechercher(){
        getAll(page.value);
      }
  
      // END PAGINATE
      const resiliation = (id: number) => {
        //show modal
        showModal(ResiliationRef.value!);
      }

  
      

      // const fetchClient = async () => {
      //   ApiService.get("/produits")
      //       .then(({ data }) => {
      //       clientOptions.value = data.data.data.map((p) => {
      //         return {
      //           value: p.id,
      //           label: "[ "+ p.code +" ] " +p.nom + " " + p.prenoms,
      //         };
      //       });
      //       console.log('clients', clientOptions.value);
      //       })
      //       .catch(({ response }) => {
      //       // produitsError.value = true;
      //       });
      // };

      // const fetchVente = async () => {
      //   ApiService.get("/ventes")
      //       .then(({ data }) => {
      //       venteOptions.value = data.data.data.map((p) => {
      //         return {
      //           value: p.id,
      //           label: p.client.code+" - "+p.montant,
      //         };
      //       });
      //       console.log('clients', venteOptions.value);
      //       })
      //       .catch(({ response }) => {
      //       // produitsError.value = true;
      //       });
      // };
  

  
      function getAll(id : number) {
        return ApiService.get(`/fiche/produit/`+ id)
          .then(({ data }) => {
            console.log('MES DONNEE', data.data);
            elements.value = data.data;

            let cumulativeTotal = 0;
            elements.value = data.data.map((el: any) => {
              
              (el.type === 'approvisionnement') 
              ? cumulativeTotal += el.quantity 
              : cumulativeTotal -= el.quantity;
             
              return {
                ...el,
                cumulativeTotal, 
              };
            });

            // elementsAppro.value = data.data.totalApprovisionnement;
            // elementsVente.value = data.data.totalVendu;
            // totalPages.value = data.data.totalPages;
            // limit.value = data.data.limit;
            // totalElements.value = data.data.totalElements;

            // total.value = reglements.value.reduce((acc,p) => {
            //   const mt = p.montant !== null && !isNaN(p.montant) ? parseFloat(p.montant.toString()) : 0;
            //   return acc + mt;
            // }, 0)
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      }
  
      onMounted(async () => {
          // await fetchClient();
          // await fetchVente();
          if(route.params.id){
            await getAll(parseInt((route.params.id).toString()));
          }
      });
  
    

    const formatMontant = (montant) => {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant);
    };
      
      return { 
        elements,
        elementsAppro,
        elementsVente,
        // checkPermission,
        modeleOptions,
        agentOptions,
        clientOptions,
        venteOptions,
        categorieAbonneOptions,
        format_date,
        suppression,
        getAll,
        resiliation,
        // resilier,
        page, 
        totalPages,
        limit,
        format_Date,
        totalElements,
        handlePaginate,
        separateur,
        searchTerm,
        rechercher,
        Multiselect,
        getCurrentDate,
        _dateDebut,
        _dateFin,
        _agent,
        _client,
        _vente,
        total,
        formatMontant
        // valideAbonnement,
        // addValidAbonnementModalRef
      };
    },
  });
  </script>
  
  